// DS: i3.37
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ReusePrompt: React.FC<Props> = props => {
  return (
    <IconWrap {...props} disableDefaultColors>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M8.488 2.535a.984.984 0 00-1.51-1.247L5.194 3.071a.8.8 0 000 1.131l1.782 1.782a.984.984 0 101.391-1.39l-.101-.103a4.258 4.258 0 012.757 1.244 4.274 4.274 0 11-7.28 2.642.984.984 0 00-1.96-.174 6.242 6.242 0 106.703-5.669z"
        />
      </svg>
    </IconWrap>
  );
};

ReusePrompt.displayName = 'ReusePrompt';

export default ReusePrompt;
